import React from 'react';
import { Col, Placeholder, Row } from 'react-bootstrap';
import CardLayout from '../../../../../../shared/components/card/CardLayout';

const OVERVIEW_STATS = 4;
const PLATFORMS = 4;
const TOUCHPOINT_STATS = 5;

const StatItem = ({ large = false }: { large?: boolean }) => (
    <div className="d-flex flex-column align-items-center align-items-md-start">
        <Placeholder className={`skeleton skeleton-stat-value ${large ? 'skeleton-stat-value-lg' : ''}`} />
        <Placeholder className="skeleton skeleton-stat-label mt-2" />
    </div>
);

export function CampaignSummarySocialNetworksSkeleton() {
    return (
        <Row aria-hidden="true">
            <div className="col-md-6 mb-3 mb-md-0">
                <CardLayout classCard="h-100">
                    <Placeholder as="div" animation="glow">
                        <Placeholder xs={4} className="skeleton d-block mb-3" />
                        <div className="d-flex flex-wrap justify-content-between mb-4" style={{ rowGap: 8 }}>
                            {Array.from({ length: OVERVIEW_STATS }).map((_, i) => (
                                <StatItem key={i} large />
                            ))}
                        </div>
                    </Placeholder>
                </CardLayout>
            </div>
            <div className="col-md-6 mb-3 mb-md-0">
                <CardLayout classCard="h-100">
                    <Placeholder as="div" animation="glow">
                        <Placeholder xs={4} className="skeleton d-block mb-3" />
                        <div className="d-flex flex-wrap justify-content-between justify-content-lg-start">
                            {Array.from({ length: PLATFORMS }).map((_, i) => (
                                <div key={i} className="w-md-25 mb-4 d-flex align-items-center">
                                    <Placeholder className="skeleton skeleton-icon" />
                                    <div className="ml-2">
                                        <Placeholder className="skeleton skeleton-stat-label d-block" />
                                        <Placeholder className="skeleton skeleton-stat-label d-block mt-1" />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Placeholder>
                </CardLayout>
            </div>
        </Row>
    );
}
const TOUCHPOINT_CARDS = 3;
const TOUCHPOINT_CARD_STATS = 2;

export function CampaignSummaryTouchpointsSkeleton() {
    return (
        <Row aria-hidden="true" style={{ rowGap: 16 }}>
            {Array.from({ length: TOUCHPOINT_CARDS }).map((_, i) => (
                <Col key={i} md={4}>
                    <CardLayout classCard="h-100">
                        <Placeholder as="div" animation="glow">
                            <Placeholder xs={5} className="skeleton d-block mb-3" />
                            <div className="d-flex flex-wrap justify-content-between" style={{ rowGap: 8 }}>
                                {Array.from({ length: TOUCHPOINT_CARD_STATS }).map((_, j) => (
                                    <StatItem key={j} large />
                                ))}
                            </div>
                        </Placeholder>
                    </CardLayout>
                </Col>
            ))}
        </Row>
    );
}
